module.exports = __webpack_public_path__ + "img/pdf-icon.4c89e756.svg";